import GOITree from "../GOITree";
import { useState } from "react";
import useObjectInput from "../../../hooks/useObjectInput";
import HeaderWithGOI from "../GOITree/NodeHeaderWithGOINode";

// This component is used to render a single node in the tree view screen
const SingleTreeNode = ({ item }) => {
  const [showField, setShowField] = useState(false);

  const toggleShowField = () => {
    setShowField(!showField);
  };

  const { editingChildrenIds } = useObjectInput();

  return (
    <HeaderWithGOI
      showField={showField}
      item={item}
      toggleShowFields={toggleShowField}
      margin={0}
      level={1}
      saving={false}
      editMode={editingChildrenIds[item.id]}
    />
  );
};

// This component is responsible for rendering the complete tree, All of the tree is shown, starting from the topmost object and going down.
// It expects the data props in the form of an object with a single key-value pair
// data is the complete tree data we get from the server
const GOICompleteTree = ({ data }) => {
  const values = Object.values(data);
  // Access the (top most node) only value assuming there's only one key-value pair
  const item = values[0];
  return (
    <div>
      {item?.children ? (
        // if the node has children, then render the whole tree
        <GOITree item={item} level={1} />
      ) : (
        // if the node has no children, then render the single node
        <SingleTreeNode item={item} />
      )}
    </div>
  );
};

export default GOICompleteTree;
